riot.tag2('bbc-id-cutover', '<div class="orb-panel-content b-g-p b-r orb-nav-sec"> <button class="orb-signin-upsell-banner--close" onclick="{this.close}">×</button> <div class="orb-signin-upsell-banner--layout"> <div class="orb-signin-upsell-banner--content"> <p class="notifications-trafalgar-bold"><i1-8n>copy.cutover.title</i1-8n></p> <p class="notifications-pica"><i1-8n>copy.cutover.body</i1-8n></p> <div id="orb-signin-upsell-banner--idcta"></div> </div> </div> </div>', '', '', function(opts) {
'use strict';

var _this = this;

require('whatwg-fetch');
var cookie = require('../cookie');
var text = require('../i18n');
var i18n = require('riot-i18n');
var config = require('../config');

var cookieName = 'ckps_bbc_idv5_cutover';
var lang = cookie.get('ckps_language');

var locale = 'en-GB';
console.log('cutover lang', lang);
if (lang && text[lang]) {
    locale = lang + '-GB';
}

this.close = function () {
    var banner = document.querySelector('.orb-signin-upsell-banner');
    if (!banner) {
        return;
    }

    banner.parentNode.removeChild(banner);

    cookie.set(cookieName, '.bbc.co.uk');
    cookie.set(cookieName, '.bbc.com');
};

function loadStylesheet(url) {
    var check = document.querySelector('link[href="' + url + '"]');
    if (check) {
        console.log('stylesheet skipped', url);
        return;
    }

    var fileref = document.createElement('link');
    fileref.rel = 'stylesheet';
    fileref.type = 'text/css';
    fileref.href = url;
    document.getElementsByTagName('head')[0].appendChild(fileref);

    console.log('stylesheet added', url);
}

this.on('mount', function () {
    console.log('mount name', cookieName);
    document.getElementById('notification-link').addEventListener('click', _this.close);

    var ptrt = encodeURIComponent(window.location.href.replace(window.location.hash, ''));

    fetch(config.env.preferencesUrls.idcta + '?purpose=continue&locale=' + locale + '&ptrt=' + ptrt, {
        credentials: 'include'
    }).then(function (result) {
        return result.json();
    }).then(function (data) {
        console.log('cta', data);

        if (data.css) {
            data.css.forEach(function (stylesheet) {
                loadStylesheet(stylesheet);
            });
        }

        var button = document.createElement('div');
        button.innerHTML = data.html;

        var buttonInner = button.querySelector('p > span');
        console.log('cta inner', buttonInner);

        var els = [].slice.call(buttonInner.childNodes);
        els.slice(1).forEach(function (el) {
            buttonInner.removeChild(el);
        });

        var buttonLabel = document.createElement('span');
        buttonLabel.style.fontWeight = 'normal';
        buttonLabel.innerHTML = ' ' + i18n.localise('copy.cutover.continue');
        buttonInner.appendChild(buttonLabel);

        _this.root.querySelector('#orb-signin-upsell-banner--idcta').appendChild(button);
    });
});
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-id-cutover.tag
 ** module id = 16
 ** module chunks = 0
 **/